import React, { useEffect, useState } from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import {isEmpty} from "../../../components/Utils/common";
import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import {Controller, useFormContext} from "react-hook-form";
import {FormControl, InputLabel, Select, Typography, Divider} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import useAllowOnlyNumber from "../../../hooks/useAllowOnlyNumber";


function MerchantBankDetails({merchant, editmode, setMerchant, type}) {
  const formMethods = useFormContext();
  const { register, formState: { errors }, control, setValue } = formMethods;
  const handleKeyDown = useAllowOnlyNumber();

  return (
      <Grid mt={3} mb={3} padding={2}>
        <Divider variant="middle" color="primary" style={{ marginBottom: '40px', marginTop: '-40px' }}>Bank Details</Divider>
        <Grid container spacing={2} justifyContent="center">

          <Grid item xs={3}>
            <MDInput
                type="text"
                label="Beneficiary Name"
                name="beneficiaryName"
                {...register("beneficiaryName")}
                fullWidth
                disabled={!editmode}
                error={errors?.beneficiaryName}
                helperText={errors?.beneficiaryName?.message}
            />
          </Grid>

          <Grid item xs={3}>
            <MDInput
                type="text"
                label="Beneficiary Account No"
                name="beneficiaryAccountNo"
                {...register("beneficiaryAccountNo")}
                fullWidth
                disabled={!editmode}
                error={errors?.beneficiaryAccountNo}
                helperText={errors?.beneficiaryAccountNo?.message}
                onKeyDown={handleKeyDown}
            />
          </Grid>

          <Grid item xs={2}>
            <MDInput
                type="text"
                label="Bank Code"
                name="bankCode"
                {...register("bankCode")}
                fullWidth
                disabled={!editmode}
                error={errors?.bankCode}
                helperText={errors?.bankCode?.message}
                onKeyDown={handleKeyDown}
            />
          </Grid>

          <Grid item xs={2}>
            <MDInput
                type="text"
                label="Branch Code"
                name="branchCode"
                {...register("branchCode")}
                fullWidth
                disabled={!editmode}
                error={errors?.branchCode}
                helperText={errors?.branchCode?.message}
                onKeyDown={handleKeyDown}
            />
          </Grid>

          <Grid item xs={2}>
            <Controller
                name="settlementCurrency"
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <MDInput
                        select
                        {...field}
                        value={field.value || ""}
                        label="Settlement Currency"
                        fullWidth
                        disabled={!editmode}
                        error={!!errors?.settlementCurrency}
                        helperText={errors?.settlementCurrency?.message}
                        sx={{ '& .MuiInputBase-root': { height: '44px' } }}
                    >
                      <MenuItem value="LKR">LKR</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                    </MDInput>
                )}
            />
          </Grid>

          {/* <Grid item xs={2}>
            <MDInput
                type="text"
                label="Transaction Code"
                name="transactionCode"
                {...register("transactionCode")}
                fullWidth
                disabled={!editmode}
                error={errors?.transactionCode}
                helperText={errors?.transactionCode?.message}
                onKeyDown={handleKeyDown}
            />
          </Grid> */}

        </Grid>
      </Grid>
  );
}

MerchantBankDetails.defaultProps = {
  merchant: false,
  editmode: false,
  setMerchant: false,
  type: 'updated'
}

MerchantBankDetails.propTypes = {
  merchant: PropTypes.any,
  editmode: PropTypes.bool,
  setMerchant: PropTypes.func,
  type: PropTypes.string
}

export default MerchantBankDetails;